import {FC, useEffect} from 'react';
import ReactSlider from 'react-slider';
import './PriceRange.css'
import {APP} from "../../Utils/Constants.ts";

interface PriceRangeProps {
  handlePriceRange: (filterId:string, value:any) => void;
  value: Filter|undefined;
  datas: number;
  title: string;
}
const PriceRange: FC<PriceRangeProps> = ({value, handlePriceRange, datas, title }) => {

  const defaultValue = () => {
    return value ? value.values : [0,datas];
  }

  const updateLabel = () => {
    const minValue = document.querySelector(".pricerange-thumb-0 .thumb-label")?.innerHTML;
    const maxValue = document.querySelector(".pricerange-thumb-1 .thumb-label")?.innerHTML;
    if (minValue !== undefined){
      document.querySelector(".min-price")!.innerHTML = minValue;
    }
    if (maxValue !== undefined){
      document.querySelector(".max-price")!.innerHTML = maxValue;
    }
  }
  const handleChange = (value: number[]) => {
      const areEqual = value.length === 2 && [0,datas].every((val, index) => val === value[index])
      areEqual ? handlePriceRange(APP.FILTER.PRICERANGE.FIELD, []) : handlePriceRange(APP.FILTER.PRICERANGE.FIELD, value);
  }

  useEffect(() => {
    updateLabel();

  },[value])

  return (
      <>
        <div className={'filter-wrapper pricerange__wrapper'}>
          <span id="filter-price-range-label" className="filter-label">{title}</span>
          <ReactSlider
            max={datas}
            value={defaultValue()}
            onChange={() => { updateLabel() } }
            onAfterChange={(value) => { handleChange(value)} }
            className="pricerange-slider"
            thumbClassName="pricerange-thumb"
            trackClassName="pricerange-track"
            ariaLabelledby="filter-price-range-label"
            renderThumb={(props, state) => (
              <div {...props}>
                <div className="thumb-label">{state.valueNow}</div>
              </div>
            )}
          />
          <div className="prices-label">
            <span className="min-price">0</span>
            <span className="max-price">{ datas }</span>
          </div>
        </div>
      </>
  );
};

export default PriceRange;
